import React from "react";
import { TransferRuleDirection } from "@common/types/transactionRule";
import { useCategoriesById } from "@hooks/useCategoriesById";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    value: string;
    transferDirection: TransferRuleDirection | null;
}

export const RuleCategoryAction: React.FC<Props> = ({
    value,
    transferDirection,
}) => {
    const categories = useCategoriesById();
    const category = categories[value];
    const categoryLabel = category?.label;

    if (!categoryLabel) {
        return null;
    }

    let directionPrefix = "";
    if (transferDirection === TransferRuleDirection.TO) {
        directionPrefix = "To ";
    } else if (transferDirection === TransferRuleDirection.FROM) {
        directionPrefix = "From ";
    }

    return (
        <RuleTagRow
            label={`${directionPrefix}Update category`}
            type="action"
            values={[categoryLabel]}
        />
    );
};
